import React from "react";

/**
 * The heading above a section on any developer page.
 *
 * ITS OWN MODULE because three pages need it — the dashboard, the containers
 * page, and whatever comes next — and the alternatives were both worse. A copy
 * per page drifts: the copy I wrote first was already missing the "shown of
 * total" case. Importing it from DeveloperDashboard.js made the containers page
 * depend on the entire dashboard component for one heading.
 *
 * `shown` and `total` together mean "filtered": when a search has narrowed a
 * section, the count reads "12 of 40" and is highlighted, so a section that
 * looks short says why rather than looking like missing data.
 */

const nf = (n) => Number(n || 0).toLocaleString();

export default function DevSectionHead({ icon: Icon, title, shown, total, children }) {
  const filtered = shown !== undefined && total !== undefined && shown !== total;
  return (
    <div className="dev-section-head">
      <h2 className="dev-section-title">
        <span className="dev-section-icon" aria-hidden="true">
          <Icon size={15} />
        </span>
        {title}
        {total !== undefined && (
          <span className={`dev-section-count${filtered ? " dev-section-count-on" : ""}`}>
            {filtered ? `${nf(shown)} of ${nf(total)}` : nf(total)}
          </span>
        )}
      </h2>
      {children && <p className="dev-section-note">{children}</p>}
    </div>
  );
}
